@if (facility$ | async; as facility) {
  @if (installation$ | async; as installation) {
    @if (visible | async) {
      <gbc-table [clickableRows]="clickable" [ngStyle]="{'min-height': minHeight}">
        <th gbc-table-header>{{'alarm-table.header-type' | translate}}</th>
        <th gbc-table-header>{{'alarm-table.header-application' | translate}}</th>
        <th gbc-table-header>{{'alarm-table.header-date' | translate}}</th>
        <th gbc-table-header>{{'alarm-table.header-override' | translate}}</th>
        @for (alarm of alarms$ | async; track trackByAlarm($index, alarm)) {
          <tr gbc-table-row (rowClicked)="alarmClick.emit(alarm)">
            <td gbc-table-cell><img class="alarm-icon" [src]="alarm.type | alarmIconLink"> {{alarm.metadata | formatAlarmMetadata }}:
            {{alarm.metadata.title}}</td>
            <td gbc-table-cell>{{alarm.application ? (alarm.application.title | async) : ''}}</td>
            <td gbc-table-cell>{{alarm.currentActivation.activatedTimestampEpoch | timeWithAgo}}</td>
            <td gbc-table-cell>
              {{manuallyOverriden(alarm) ? ('alarm-table.override-yes' | translate) : ('alarm-table.override-no' | translate)}}
            </td>
          </tr>
        }
      </gbc-table>
    } @else {
      <div class="no-alarms-container" [ngStyle]="{'min-height': minHeight}">
        <div>{{noAlarmsMessage}}
        </div>
      </div>
    }
  }
}
